module.exports = __webpack_public_path__ + "img/work.02ef8447.svg";